import ConfirmationDialog from "components/common/ConfirmationDialog";

interface Props {
  onCancel?: () => void;
  onApply?: () => void;
}

export default function DeleteAccountConfirmationPopup(props: Props) {
  const { onCancel, onApply } = props;

  const contentComponent = () => {
    return (
      <div className="text-sm">
        <div>
          Your account will be disabled, and you will not be able to login using
          this account.
        </div>
        <div className="mt-2 font-semibold">
          After 90 days your account and all related information will be
          permanently deleted.
        </div>
      </div>
    );
  };

  return (
    <>
      <ConfirmationDialog
        title="Delete user account"
        width="450"
        onCancel={onCancel}
        onConfirm={onApply}
        confirmButtonText="Confirm"
        contentComponent={contentComponent}
      />
    </>
  );
}
